module.exports = __webpack_public_path__ + "static/weather-web-dark-plp-3ccfb6d20d5680886a36e23b72e08351.png";